import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation, inject } from '@angular/core';

import { LayoutFacade } from '@web/store/layout/layout.facade';

@Component({
    selector: 'web-settings-breadcrumbs',
    templateUrl: './settings-breadcrumbs.component.html',
    styleUrls: ['./settings-breadcrumbs.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class SettingsBreadcrumbsComponent {
    private readonly layoutFacade = inject(LayoutFacade);

    @Output() public readonly cancelEvent = new EventEmitter<void>();

    public closePanel(): void {
        this.layoutFacade.hideSelectedEntitySettings();
        // this.layoutFacade.unsetEntity();
        this.cancelEvent.emit();
    }
}
